export const easeInOutCubic = (t: number): number => {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
};

export const animate = (
  duration: number,
  onTick: (progress: number) => void,
  onComplete: () => void
): (() => void) => {
  const startTime = performance.now();
  let rafId: number | null = null;

  const step = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(1, elapsed / duration);
    const easedProgress = easeInOutCubic(progress);

    onTick(easedProgress);

    if (progress < 1) {
      rafId = requestAnimationFrame(step);
    } else {
      onComplete();
    }
  };

  rafId = requestAnimationFrame(step);

  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
  };
};
